import { cn } from "@/common/helpers/utils";
import { usePermittedRecentVisits } from "@/common/hooks/use-permitted-recent-visits";
import { motion } from "framer-motion";
import { HistoryIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "wouter";

export function JumpBackIn() {
  const { t } = useTranslation("home");
  const permittedVisits = usePermittedRecentVisits();

  if (permittedVisits.length === 0) return null;

  return (
    <section className="space-y-2">
      <motion.h2
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        className="text-muted-foreground text-xs font-medium tracking-wide uppercase"
      >
        {t("JumpBackIn")}
      </motion.h2>
      <div className="flex flex-wrap gap-2">
        {permittedVisits.map(({ visit, navigationItem, moduleItem }, index) => {
          const Icon = moduleItem?.icon ?? navigationItem.icon ?? HistoryIcon;

          return (
            <motion.div
              key={visit.path}
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, ease: "easeInOut", delay: (index + 1) * 0.05 }}
            >
              <Link
                to={`~${visit.path}`}
                className={cn(
                  "border-border bg-card hover:bg-accent hover:text-accent-foreground flex items-center gap-2",
                  "rounded-lg border px-3 py-2 text-sm transition-colors",
                )}
              >
                <Icon className="text-primary h-4 w-4 shrink-0" />
                <span className="max-w-48 truncate">{visit.title}</span>
              </Link>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
